export type JsonFieldValue =
  | string
  | number
  | boolean
  | null
  | JsonFieldValue[]
  | { [key: string]: JsonFieldValue }

export interface JsonObject {
  [key: string]: JsonFieldValue
}

interface StringRecord {
  [key: string]: string
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value)
}

function isJsonFieldValue(value: unknown): value is JsonFieldValue {
  if (
    value === null ||
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return true
  }

  if (Array.isArray(value)) {
    return value.every(isJsonFieldValue)
  }

  if (!isPlainObject(value)) {
    return false
  }

  return Object.values(value).every(isJsonFieldValue)
}

export function isJsonObject(value: unknown): value is JsonObject {
  return isPlainObject(value)
}

export function isJsonObjectValue(value: unknown): value is JsonObject {
  return isPlainObject(value) && Object.values(value).every(isJsonFieldValue)
}

function isStringRecord(value: unknown): value is StringRecord {
  return (
    isPlainObject(value) &&
    Object.values(value).every((v) => typeof v === "string")
  )
}

export function asJsonObjectOrNull(value: unknown): JsonObject | null {
  return isJsonObject(value) ? value : null
}

export function asJsonObjectValueOrNull(value: unknown): JsonObject | null {
  return isJsonObjectValue(value) ? value : null
}

export function asJsonFieldValueOrNull(value: unknown): JsonFieldValue | null {
  return isJsonFieldValue(value) ? value : null
}

export function asStringRecordOrNull(value: unknown): StringRecord | null {
  return isStringRecord(value) ? value : null
}
